import { InterfaceTypes }  from 'HostInterface/InterfaceFactory';
import InteractionMeasurer from './InteractionMeasurer';
import ApplicationMeasurer from './ApplicationMeasurer';
import ViewabilityMeasurer from './ViewabilityMeasurer';
import ExternalMeasurer    from './ExternalMeasurer';

export const getMeasurers = type => {
  switch(type) {
    case InterfaceTypes.VPAID:
      return [InteractionMeasurer, ApplicationMeasurer, ViewabilityMeasurer, ExternalMeasurer].map( measurer => new measurer() );
  }
};


// WEBPACK FOOTER //
// ./src/Services/Measurement/MeasurerFactory.js